import { render, staticRenderFns } from "./package.vue?vue&type=template&id=b317f67e&scoped=true"
import script from "./package.vue?vue&type=script&lang=js"
export * from "./package.vue?vue&type=script&lang=js"
import style0 from "./package.vue?vue&type=style&index=0&id=b317f67e&prod&lang=scss"
import style1 from "./package.vue?vue&type=style&index=1&id=b317f67e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b317f67e",
  null
  
)

export default component.exports